<template>
  <div class="p-2 grid grid-cols-1 md:grid-cols-4 gap-2">
    <button class="flex flex-col justify-center bg-gray-200 border shadow-sm rounded hover:border-gray-600" v-for='(image,i) in images' :key='image.url + "-" + i' @click='select(image)'>
      <img class="object-contain w-full h-24 md:h-24" :src='image.url' loading="lazy" />
      <div class="mt-1 tracking-tight font-semibold truncate self-center">{{image.name}}</div>
      <div class="mt-2 text-sm text-gray-600 self-center">{{image.description}}</div>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  methods: {
    select(image) {
      this.$emit('select', image);
    }
  }
}
</script>
